<template>
  <div class="license-status-table">
    <vxe-table
      :data="tableDataC"
      :span-method="rowspanMethod"
      border
      style="width: max-content;">
      <vxe-table-column
        field="label"
        :title="$t('scope.text_21')"
        width="180" />
      <vxe-table-column
        field="status"
        :title="$t('scope.text_119')"
        width="180">
        <template v-slot="{ row }">
          <status :status="row.status" statusModule="licence" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="usage"
        :title="$t('scope.text_120')"
        width="180">
        <template v-slot="{ row }">
          <span class="mr-1">{{ row.usage }}</span>
          <a-tooltip placement="right">
            <template slot="title">
              <div>{{ row.tooltip.title }}</div>
              <ul class="usage-list">
                <li>{{ row.tooltip.info.usage }}</li>
                <li>{{ row.tooltip.info.noUsage }}</li>
              </ul>
            </template>
            <a-icon type="question-circle-o" />
          </a-tooltip>
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="hasServer"
        field="limit"
        :title="$t('scope.text_121')"
        width="180" />
      <vxe-table-column
        field="ratio"
        :title="$t('scope.text_122')"
        width="180">
        <template slot-scope="scope">
          <span :style="{color: getRatioColor(scope.row.ratio)}">{{ scope.row.ratio }}%</span>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import * as R from 'ramda'

export default {
  props: {
    statusData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasServer () {
      if (!R.isNil(this.statusData.server_limit)) {
        return true
      }
      return false
    },
    tableDataC () {
      const list = [
        {
          label: this.$t('scope.text_123'),
          status: this.getStatus(this.statusData),
          tooltip: {
            title: this.$t('scope.text_124'),
            info: {
              usage: this.$t('scope.text_125', [this.statusData.host_usage_details.kvm]),
              noUsage: this.$t('scope.text_126', [this.statusData.host_usage_details['non-kvm']]),
            },
          },
          usage: this.statusData.usage || 0,
          limit: this.statusData.limit || 0,
          ratio: this.getRatio(this.statusData.usage, this.statusData.limit),
        },
        {
          label: this.$t('scope.text_127'),
          status: this.getStatus(this.statusData),
          tooltip: {
            title: this.$t('scope.text_128'),
            info: {
              usage: this.$t('scope.text_129', [this.statusData.server_usage_details.server]),
              noUsage: this.$t('scope.text_130', [this.statusData.server_usage_details['non-server'], this.statusData.server_usage_details['non-server'] / 10]),
            },
          },
          usage: this.statusData.server_usage || 0,
          limit: this.statusData.server_limit || 0,
          ratio: this.getRatio(this.statusData.server_usage, this.statusData.server_limit),
        },
      ]
      return list
    },
  },
  methods: {
    getRatio (usage, limit) {
      if (usage && limit) {
        return parseFloat((parseFloat(usage) / parseFloat(limit) * 100).toFixed('2'))
      }
      return 0
    },
    getRatioColor (count) {
      let color = ''
      if (count >= 101) {
        color = 'orange'
      }
      if (count > 110) {
        color = '#DD2727'
      }
      return color
    },
    getStatus (statusData) {
      if (statusData.prohibited) {
        // TO DO 禁用
        return 'prohibited'
      }
      if (statusData.exceeded) {
        // TO DO 警告
        return 'exceeded'
      }
      return 'success'
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    rowspanMethod ({ row, $rowIndex, column, data }) {
      const fields = ['status']
      const cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        const prevRow = data[$rowIndex - 1]
        let nextRow = data[$rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = data[++countRowspan + $rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
.usage-list {
  margin: 0;
  padding: 0;
  li:before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    position: relative;
    top: -2px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.8);
    margin-right: 6px;
  }
}
</style>
